import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/BillOfLading/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__heading-box')}>
          <h2 className={cn('about__heading')}>What is a Bill of Lading?</h2>
          <p className={cn('about__heading-description')}>
            A Bill of Lading (BoL) is a critical document in the shipping and logistics industry, serving
            multiple roles: a receipt for goods shipped, a document of title, and a contract between the
            shipper and the carrier. It is a document issued by the carrier to acknowledge receipt of goods
            and to facilitate their transfer during transit. As a title document, the bill of lading enables the
            transfer of ownership of goods in transit. Its main functions are as a receipt, a title document,
            and evidence of the contract of carriage. The bill of lading serves three main functions in
            international trade: as a receipt, a title document, and a contract of carriage. Essentially, it is
            the paperwork that documents the safe and legal transport of goods from one place to
            another.
          </p>
        </div>

        <div className={cn('about__purpose-box')}>
          <h3 className={cn('about__purpose-heading')}>Purpose and Importance</h3>
          <div className={cn('about__purpose-content')}>
            <p className={cn('about__purpose-description')}>
              The BoL details the type, quantity, and destination of the goods being carried. It is issued by a
              carrier to a shipper and serves as a shipment receipt when the carrier delivers the goods at a
              predetermined destination. A Bill of Lading is issued after the vessel has departed from the
              port of loading. The importance of the BoL cannot be overstated; it is a legally binding
              document that provides evidence of the contract of carriage, helps prevent fraud, and is
              essential for customs clearance and cargo claims. As a document of title, the bill of lading
              allows the buyer to claim the goods upon arrival, as it serves as proof of ownership. The bill of
              lading can also be endorsed to transfer title to another party during transit, making it a crucial
              instrument in international trade. The document contains the following details:
            </p>
            <ul className={cn('about__benefits')}>
              <li className={cn('about__benefit')}>Party Information: Includes the shipper, consignee, and any notify party.</li>
              <li className={cn('about__benefit')}>Cargo Description: Detailed information about the goods being transported.</li>
              <li className={cn('about__benefit')}>Cargo Specifications: Weight, number of packages, and volume of the cargo.</li>
              <li className={cn('about__benefit')}>Payment Terms: Specifies the conditions and terms of payment.</li>
              <li className={cn('about__benefit')}>Loading Port: The port where the cargo is initially loaded.</li>
              <li className={cn('about__benefit')}>Discharge Port: The destination port where the cargo will be unloaded.</li>
              <li className={cn('about__benefit')}>Bill Type: Indicates the type of Bill of Lading used for the shipment.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionAbout;